module.exports = __webpack_public_path__ + "static/media/03.207bb83e.svg";